<template>
    <v-app>

      <TileSimple :values="values">

         <template v-slot:title>
            <h5>{{ $tc('texts.accounts', accounts.count, { count: accounts.count }) }} {{ $t('titles.tile_backupbareos') }}</h5>
         </template>

         <template v-slot:header>
            <h4>{{ values.value }} {{ values.unit }}</h4>
         </template>

         <template v-slot:dropdown>
            <b-dropdown dropdown class="float-right" variant="transparent p-0" right>
               <template slot="button-content">
                  <i class="icon-settings"></i>
               </template>
               <b-dropdown-item href="/#/platform/servicebackupbareos">{{ $t('titles.backupbareos_details') }}</b-dropdown-item>
               <b-dropdown-divider></b-dropdown-divider>
               <b-dropdown-item @click="switch_type('month','jobs')">{{ $t('texts.smtppro_mails_month') }}</b-dropdown-item>
               <b-dropdown-item @click="switch_type('last30','jobs')">{{ $t('texts.smtppro_mails_last30') }}</b-dropdown-item>
               <b-dropdown-divider></b-dropdown-divider>
               <b-dropdown-item @click="showFullGraph=true">ZOOM</b-dropdown-item>
            </b-dropdown>
         </template>

         <template v-slot:message>
            <p>{{ values.message }}</p>
         </template>

         <template v-slot:graph>
            <ddoGraphBar v-if="loaded" ref="myGraphLine" :chartdata="chartdata" :options="options" :height="height"/>
         </template>

      </TileSimple>

    </v-app>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import TileSimple from '@/components/partials/TileSimple.vue';
import ddoGraphBar from '@/components/ddoGraphBar.vue';

export default {
   name: 'TileSimpleBACKUPBAREOS',
   components: {
      TileSimple,
      ddoGraphBar,
   },

   data: function () {
      return {

         locale: null,
         accounts : {
            count: null,
            rows: [],
            current_type: null,
            current_data: null,
            current_account: 'null',
            per_status: false,
         },

         ws_code: 'service',
         ws_key: 'BACKUP-BAREOS',
         ws_stats_keyword: 'stats',
         ws_search_code: 'service_backupbareos',
         ws_search_keyword: 'search',
         ws_report_type: 'month',

         loading: false,
         loaded: false,
         chartdata: null,
         options: null,
         ZOOMoptions: null,
         height: 250,
         data_type: 'jobs',
         rows: [],
         bgcolors: [],
         showFullGraph: false,

         dropdown_graph_text: i18n.t('texts.choose_dropdown_graph'),

         values : {
            value: null,
            total_messages: null,
            total_bytes: null,
            message : null,
            labels: [],
            date: [],
            data: [],
            data1: [],
            data2: [],
            data3: [],
         } 
      }
   },

   async mounted() {
      var style = getComputedStyle(document.body);
      this.bgcolors[0] = style.getPropertyValue('--success');
      this.bgcolors[1] = style.getPropertyValue('--warning');
      this.bgcolors[2] = style.getPropertyValue('--danger');

      await this.refresh_data();

      this.accounts.current_type = this.ws_report_type;
      this.accounts.current_data = this.data_type;
   },

   methods : {

      async switch_type(report_type,data_type) {
         this.data_type = data_type;
         this.ws_report_type = report_type;
         await this.refresh_data();
      },

      async refresh_data() {
         var type = this.ws_report_type;
         if ( this.ws_report_type=='month_cum' ) { type = 'month'; }
         var parameters = { plf_report_type: type };
         this.loaded = false;
         let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_code+'/'+this.ws_key+'/'+this.ws_stats_keyword, parameters );
         if ( api_response.error==0 ) {
            this.restructure_data(api_response.rows);
            this.loaded = true;
         }
      },

      get_max(data,_min=0) {
         var _max = _min;
         for( var i=0;i<data.length;i++ ) {
            if ( data[i]>_max ) { _max = data[i]; }
         }
         return _max;
      },

      compute_currentmonth(data) {
         if (data[0] && data[0].prl_day) {
            var _date = new Date(data[0].prl_day);
         } else {
            var _date = new Date(data[0].prl_day);
         }
         var _month = _date.getMonth();
         return _month;
      },

      build_labels(report_type,data,length) {
         var labels = [];
         var _format = 'short';
         if ( report_type=='last12months' ) {
             _format = 'monthly';
         }
         for (var i=0;i<data.length;i++) {
            labels.push( this.$api._d(data[i],_format) );
         }
         if ( labels.length<length && report_type=='month' ) {
            for (var i=labels.length;i<length;i++) {
               labels.push( '' );
            }
         }
         return labels;
      },

      build_bgcolors(report_type,data,length) {
         var bgcolors = [];
         for (var i=0;i<data.length;i++) {
            bgcolors.push( this.bgcolors[data[i]] );
         }
         if ( bgcolors.length<length ) {
            for (var i=bgcolors.length;i<length;i++) {
               bgcolors.push( '' );
            }
         }
         return bgcolors;
      },

      build_options(report_type,data) {
         var options = {
            legend: {
               display: false,
            },
            scales: {
               xAxes: [ {
                  display: false,
                  stacked: true,
               }],
               yAxes: [ {
                  display: false,
                  stacked: true,
                  ticks: {
                     min: 0,
                     max: this.get_max(data),
                  }
               }]
            }
         };
         return options;
      },

      build_ZOOMoptions(report_type,data) {
         var options = {
            scales: {
               xAxes: [ {
                  display: true,
                  stacked: true,
               }],
               yAxes: [ {
                  display: true,
                  stacked: true,
                  ticks: {
                     min: 0,
                     max: this.get_max(data),
                  }
               }]
            }
         };
         return options;
      },

      prepare_chart_data(values) {
         var dataset_label = 'YYY';
         switch ( this.data_type ) {
            case 'jobs':
               values.value = values.total_jobs;
               values.unit = i18n.t('texts._jobs').toLowerCase();
               switch( this.ws_report_type ) {
                  case 'month'        : values.message = i18n.t('texts.backupbareos_jobs_day_short'); break;
                  case 'last30'       : values.message = i18n.t('texts.backupbareos_jobs_last30_short'); break;
                  case 'last12months' : values.message = i18n.t('texts.backupbareos_jobs_last12months_short'); break;
               }
               dataset_label = i18n.t('headers.messages');
               break;
         }

         var _nb_of_rows = 31;
         if ( this.ws_report_type=='last12months') {
            _nb_of_rows = 12;
         }
         this.chartdata = {
            labels : this.build_labels(this.ws_report_type,values.date,_nb_of_rows),
            datasets: [
               {
                  label: i18n.t('texts.level_ok_short'),
                  backgroundColor: this.bgcolors[0],
                  data: values.data1
               },
               {
                  label: i18n.t('texts.level_warning_short'),
                  backgroundColor: this.bgcolors[1],
                  data: values.data2
               },
               {
                  label: i18n.t('texts.level_error_short'),
                  backgroundColor: this.bgcolors[2],
                  data: values.data3
               },
            ]
         };
         this.options = this.build_options('month',values.data);
         this.ZOOMoptions = this.build_ZOOMoptions('month',values.data);
         this.values = values;
      },

      restructure_data(rows) {
         var values = { value: 0, total_jobs: 0, message: 'XX', labels: [], date: [], data1: [], data2: [], data3: [], data: [] }
         var row_lastindex = rows.length-1;
         for ( var i=0; i<rows.length; i++ ) {

            // If last row, and first time (count==null), we analyze and store number of accounts, and list of accounts
            if ( i==row_lastindex ) {
               this.accounts.count = rows[i].account_count;
               let accountrows = rows[i].account_list.split(',');
               if ( this.accounts.count>1 ) {
                  this.accounts.rows.push( { _pk: -1, code: 'null', name: '*' } );
               }
               for (var j=0;j<accountrows.length;j++) {
                  this.accounts.rows.push( { _pk: j, code: accountrows[j], name: accountrows[j] } );
               }
            }

            values.date.push(rows[i].prl_day);
            values.data1.push(parseInt(rows[i].prl_count0_0));
            values.data2.push(parseInt(rows[i].prl_count0_1));
            values.data3.push(parseInt(rows[i].prl_count0_2));
            values.data.push(parseInt(rows[i].prl_count0));
         }

         if ( rows.length>0 ) {
            values.total_jobs = parseInt(rows[rows.length-1].prl_count0);
            values.value = parseInt(rows[rows.length-1].prl_count0);
         }
         this.prepare_chart_data(values);
      },

   }

}
</script>